import { render, staticRenderFns } from "./ModalSettingAccountPasswordChange.vue?vue&type=template&id=ded20214&"
import script from "./ModalSettingAccountPasswordChange.vue?vue&type=script&lang=js&"
export * from "./ModalSettingAccountPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports